import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51093a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "power-solution-card col-12 col-sm-7 col-lg-4 mb-4" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "text-primary-residential fw-900" }
const _hoisted_4 = { class: "d-block fw-bold" }
const _hoisted_5 = { class: "fw-900" }
const _hoisted_6 = { class: "h4 my-4" }
const _hoisted_7 = { class: "d-block text-uppercase" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary-residential" }, "Learn more", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.url,
      class: "d-block d-lg-inline-block border border-dark border-3"
    }, {
      default: _withCtx(() => [
        (_ctx.displayNumber)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `${require('@/assets/' + _ctx.imgUrl)}`,
              alt: `Power Solution ${_ctx.displayNumber}`
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("small", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.kilowattsHybrid), 1),
            _createTextVNode("KW")
          ])
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("b", _hoisted_7, _toDisplayString(_ctx.kilowattsHybrid) + "kW Hybrid Kit", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.kilowattsLithium) + "kWh Lithium ", 1)
        ]),
        _hoisted_8
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}